<template>
  <article class="c-content--sendPoint c-scrollbar">
    <div class="c-content--app_container">
      <h2 class="c-text-left">Seleccionar tipo de envío</h2>
      <div class="c-type-point c-content--box-shadow">
        <div class="c-content--shadow">
          <div class="c-content--point-sharff">
            <img
              src="~@/assets/img/service-sharff-point.svg"
              alt="imagen"
              load="lazy"
              class="img-fluid"
            />
            <h2>Envía</h2>
          </div>
          <div class="c-section--content-date-options">
            <div
              class="c-collection collection d-flex m-0 collection-option text-left border-none"
            >
              <div class="collection-item pb-3">
                <label class="c-radio-buttons c-rb-item-type-doc"
                  ><input @click="trackEvent('click_puntos_envia_paso_1', 'dropoff')"
                    v-model="type"
                    value="1"
                    name="option-shipping-type"
                    type="radio"
                    class="c-option-shipping-type"
                  />
                  <span
                    >Lleva tu paquete al Punto Scharff más cercano. Nosotros nos
                    encargamos de recogerlo y enviarlo al destino que
                    necesites.</span
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="c-content--shadow">
          <div class="c-content--point-sharff">
            <img
              src="~@/assets/img/service-sharff-point-2.svg"
              alt="imagen"
              load="lazy"
              class="img-fluid"
            />
            <h2>Recojo</h2>
          </div>
          <div class="c-section--content-date-options">
            <div
              class="c-collection collection d-flex m-0 collection-option text-left border-none"
            >
              <div class="collection-item">
                <label class="c-radio-buttons c-rb-item-type-doc"
                  ><input @click="trackEvent('click_puntos_recojo_paso_1', 'pickup')"
                    v-model="type"
                    value="2"
                    name="option-shipping-type"
                    type="radio"
                    class="c-option-shipping-type"
                  />
                  <span
                    >¡No te muevas de casa! Nosotros recogemos tu paquete y lo
                    llevamos al Punto Scharff que elijas, para que tu
                    cliente/prim@/etc. lo recoja</span
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="pt-4 pb-4">
        <div class="m-0 d-flex justify-content-center">
          <a
            id="btnOpenModalRestriction"
            class="c-button c-button--five c-button--mobile-small waves-effect restriccion"
          >
            Ver restricciones<img
              src="~@/assets/img/icon/icon-danger.svg"
              alt="icon"
              load="lazy"
          /></a>
        </div>
      </div> -->
    </div>
  </article>
</template>

<script>
export default {
  name: "Step1-Content",
  computed: {
    type: {
      get() {
        return this.$store.getters.SCHARFFPOINT_ORDER_TYPE;
      },
      set(value) {
        this.$store.dispatch("SCHARFFPOINT_ORDER_TYPE", value);
      },
    },
  },
  mounted() {
    this.$eventBus.$on("validateScharffPointStep1", () => {
      this.validateStep1();
    });
  },
  methods: {
    validateStep1() {
      if (this.type === null || this.type === "") {
        this.showError("Debes seleccionar el tipo de envío");
        return false;
      }
      this.$store.dispatch("SCHARFFPOINT_PROGRESS_NAV_STEP", 2);

      this.trackEvent('click_puntos_paso_1_continuar')
      return true;
    },
  },
};
</script>

<style></style>
